import React from 'react';
import { useCart } from '../../../hooks/useCart';

export function MiniCartUnderlay() {
  const { closeMinicart } = useCart();
  return <div onClick={closeMinicart} className="minicart-underlay"></div>;
}
